export const GET_CALENDAR = 'GET_CALENDAR'
export const SET_CALENDAR = 'SET_CALENDAR'
export const UPDATE_SELECTED_CALENDAR_DATE = 'UPDATE_SELECTED_CALENDAR_DATE'
export const SET_SCHEDULING_NOTES = 'SET_SCHEDULING_NOTES'
export const SET_CALENDAR_DATE = 'SET_CALENDAR_DATE'
export const SET_SCHEDULING_ESCALATION = 'SET_SCHEDULING_ESCALATION'
export const REFRESH_QUOTA_WITH_DATE = 'REFRESH_QUOTA_WITH_DATE'
export const SET_VALIDATE_INSTALL_RESPONSE = 'SET_VALIDATE_INSTALL_RESPONSE'
export const SET_CALENDAR_OPTION = 'SET_CALENDAR_OPTION'
export const SWITCH_CALENDAR_OPTION = 'SWITCH_CALENDAR_OPTION'

export function getCalendar() {
  return {
    type: GET_CALENDAR
  }
}

export function setCalendar(calendar) {
  return {
    type: SET_CALENDAR,
    payload: { calendar }
  }
}

export function updateSelectedCalendarDate(calendarType, selectedDate) {
  return {
    type: UPDATE_SELECTED_CALENDAR_DATE,
    payload: { calendarType, selectedDate }
  }
}

export function setCalendarDate(calendarType, selectedDate) {
  return {
    type: SET_CALENDAR_DATE,
    payload: { calendarType, selectedDate }
  }
}

export function setSchedulingNotes(notes) {
  return {
    type: SET_SCHEDULING_NOTES,
    payload: { notes }
  }
}

export function setSchedulingEscalation(field, value) {
  return {
    type: SET_SCHEDULING_ESCALATION,
    payload: { field, value }
  }
}

export function refreshQuotaWithDate(selectedDate, calendarType) {
  return {
    type: REFRESH_QUOTA_WITH_DATE,
    payload: { selectedDate, calendarType }
  }
}

export function setValidateInstallResponse(response) {
  return {
    type: SET_VALIDATE_INSTALL_RESPONSE,
    payload: { response }
  }
}

export function setCalendarOption(optionType) {
  return {
    type: SET_CALENDAR_OPTION,
    payload: { optionType }
  }
}

export function switchCalendarOption(optionType) {
  return {
    type: SWITCH_CALENDAR_OPTION,
    payload: { optionType }
  }
}

export const SET_REFRESHED_DATES = 'SET_REFRESHED_DATES'

export function setRefreshedDates(refreshedDates) {
  return {
    type: SET_REFRESHED_DATES,
    payload: { refreshedDates }
  }
}
